var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "star_svg__outer",
    d: "m19.47 29.51-9.9 7.45c-.51.35-1.2.2-1.55-.33-.17-.28-.23-.62-.14-.94l3.22-11.97-9.43-7.74c-.48-.39-.56-1.12-.18-1.62.2-.26.5-.42.83-.43l12.04-.54 4.22-11.64a1.101 1.101 0 0 1 2.09 0l4.22 11.64 12.04.54c.62.03 1.1.56 1.07 1.2-.02.33-.17.64-.42.85l-9.43 7.74 3.22 11.97c.16.61-.19 1.25-.78 1.42-.31.09-.65.03-.92-.15l-10.2-7.45z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "star_svg__inner",
    d: "m19.47 29.51-9.9 7.45c-.51.35-1.2.2-1.55-.33-.17-.28-.23-.62-.14-.94l3.22-11.97-9.43-7.74c-.48-.39-.56-1.12-.18-1.62.2-.26.5-.42.83-.43l12.04-.54 4.22-11.64a1.101 1.101 0 0 1 2.09 0l4.22 11.64 12.04.54c.62.03 1.1.56 1.07 1.2-.02.33-.17.64-.42.85l-9.43 7.74 3.22 11.97c.16.61-.19 1.25-.78 1.42-.31.09-.65.03-.92-.15l-10.2-7.45z",
    fill: "currentColor"
  })));
};
export default SvgStar;